import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { PromoInfo } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.promoInfo.items
const ids = (state: AppGlobalState) => state.promoInfo.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): PromoInfo | undefined => state.promoInfo.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<PromoInfo> =>
  state.promoInfo.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.promoInfo.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.promoInfo.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.promoInfo.listFetchError
const listFetchErrorDetail = (state: AppGlobalState) => state.promoInfo.listFetchErrorDetail
const listFetchNextProgress = (state: AppGlobalState) => state.promoInfo.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.promoInfo.listFetchNextError
const listFetchNextErrorDetail = (state: AppGlobalState) => state.promoInfo.listFetchNextErrorDetail
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: PromoInfo[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.promoInfo.filter
const sorting = (state: AppGlobalState) => state.promoInfo.sorting
const page = (state: AppGlobalState) => state.promoInfo.page
const total = (state: AppGlobalState) => state.promoInfo.total
const updateProgress = (state: AppGlobalState) => state.promoInfo.updateProgress
const removeProgress = (state: AppGlobalState) => state.promoInfo.removeProgress
const addProgress = (state: AppGlobalState) => state.promoInfo.addProgress
const hasNext = (state: AppGlobalState) => state.promoInfo.total > state.promoInfo.ids.length
const pageSize = (state: AppGlobalState) => state.promoInfo.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.promoInfo.total / state.promoInfo.pageSize)

const PromoInfoSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  listFetchErrorDetail,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  listFetchNextErrorDetail,
  pages,
}

export default PromoInfoSelectors
